import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=b29e3c84&scoped=true&"
import script from "./ExamList.vue?vue&type=script&lang=js&"
export * from "./ExamList.vue?vue&type=script&lang=js&"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=b29e3c84&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29e3c84",
  null
  
)

export default component.exports